/**
 * 手机号格式化
 * @param {String} phone
 */
const formatPhone = (phone) => {
    phone = phone.toString();
    return phone.substr(0, 3) + '****' + phone.substr(7, 11);
};

const formatIdCard = (idCard) => {
    idCard = idCard.toString();
    return idCard.substr(0, 4) + '********' + idCard.substr(14, 18);
}

export default {
    formatPhone,
    formatIdCard
}



// WEBPACK FOOTER //
// ./src/filters/index.js